// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_fc-0";
export var fulfillmentPanelBody = "_fc-1";